import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { waLink, WA, IMAGES } from "../config/site";

const CATS = [
  {
    id: "ladies-wear",
    name: "Ladies' Wear",
    sub: "Sarees, salwars, kurtis & daily wear",
    img: IMAGES.ladies,
    span: "md:col-span-7",
    h: "h-72 sm:h-96",
  },
  {
    id: "gents-wear",
    name: "Gents' Wear",
    sub: "Shirts · T-shirts · Trousers · Pants",
    img: IMAGES.gents,
    span: "md:col-span-5",
    h: "h-72 sm:h-96",
  },
  {
    id: "footwear",
    name: "Footwear",
    sub: "Paragon · Walkaroo · Flite · VKC",
    img: IMAGES.footwear,
    span: "md:col-span-4",
    h: "h-64 sm:h-80",
  },
  {
    id: "innerwear",
    name: "Innerwear",
    sub: "Rupa · Dollar · Jockey · Ramraj",
    img: IMAGES.innerwear,
    span: "md:col-span-4",
    h: "h-64 sm:h-80",
  },
  {
    id: "bags",
    name: "Bags",
    sub: "Travel bags, handbags & backpacks",
    img: IMAGES.bags,
    span: "md:col-span-4",
    h: "h-64 sm:h-80",
  },
  {
    id: "accessories",
    name: "Accessories",
    sub: "Caps, gloves, belts & more",
    img: IMAGES.accessories,
    span: "md:col-span-4",
    h: "h-64 sm:h-80",
  },
  {
    id: "boutique",
    name: "Boutique & Alterations",
    sub: "Perfect fitting for men & women",
    img: IMAGES.boutique,
    span: "md:col-span-4",
    h: "h-64 sm:h-80",
  },
  {
    id: "home-comfort",
    name: "Pillows & Mattresses",
    sub: "Home-comfort essentials",
    img: IMAGES.home,
    span: "md:col-span-4",
    h: "h-64 sm:h-80",
  },
];

export const Categories = () => (
  <section id="categories" className="py-16 sm:py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-5">
        <div className="max-w-xl">
          <Eyebrow>Shop by Category</Eyebrow>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-cream text-balance">
            A little of everything, done well.
          </h2>
        </div>
        <p className="text-sm sm:text-base text-cream/50 max-w-xs leading-relaxed">
          Tap any category to ask us on WhatsApp — we'll confirm availability
          and sizes for you.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-5 lg:gap-6">
        {CATS.map((c, i) => (
          <Reveal key={c.id} delay={(i % 3) * 0.08} className={c.span}>
            <a
              href={waLink(WA.category(c.name))}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`category-card-${c.id}`}
              className={`group relative block ${c.h} rounded-3xl overflow-hidden border border-white/10 hover:border-gold/40 transition-colors duration-500`}
            >
              <img
                src={c.img}
                alt={`${c.name} at Om Sri Sri Collection — garments and footwear store`}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between gap-4">
                <div>
                  <h3 className="font-display text-2xl font-semibold text-cream">
                    {c.name}
                  </h3>
                  <p className="mt-1 text-xs sm:text-sm text-cream/60">{c.sub}</p>
                </div>
                <span className="shrink-0 w-11 h-11 rounded-full border border-cream/25 flex items-center justify-center text-cream group-hover:bg-gold group-hover:text-charcoal group-hover:border-gold transition-all duration-300">
                  <ArrowUpRight size={18} />
                </span>
              </div>
              <span className="absolute top-5 left-6 font-mono text-[10px] uppercase tracking-[0.25em] text-cream/70 bg-charcoal/50 backdrop-blur-md rounded-full px-3.5 py-1.5 border border-white/10">
                Enquire on WhatsApp
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
